const funcion = {
  IniciarSesion: 'Forseti/ValidaYObtenPermisos'
}

export default funcion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SINOJ/funcion/funcionSINOJ.js
// module id = null
// module chunks = 